// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"823":"c72825a1","938":"cc6b9f9d","960":"b72ee52d"}[chunkId] + ".chunk.js";
};